// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Checkout/style.css
// module id = 1781
// module chunks = 0